export enum TrusteeContactType {
  LEGAL_REPRESENTATIVE = 'LEGAL_REPRESENTATIVE',
  OTHER = 'OTHER',
  ADMINISTRATIVE = 'ADMINISTRATIVE',
  CUSTOMER_PROSPECT = 'CUSTOMER_PROSPECT',
  ACCOUNTANT = 'ACCOUNTANT',
}
